import axios from "axios";
import API_BASE_URL from "./apiConfig";

// Login API call
export const operationLogisticLogin = async (request) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/auth/logistic_operation/login`, request);
    return response.data; // return API response
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

export const clientLogin = async (request) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/auth/client/login`, request);
    return response.data; // return API response
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};
